const styles = {
  container: {
    height: '100vh',
    width: '100vw',
    position: 'fixed',
    left: 0,
    right: 0,
    top: 0,
  },
};

export default styles;
